<template>
    <section class="container account-form">
        <section class="form-nav">
            <button
                class="nav-item"
                @click="changePage(1)"
                :class="{ 'active' : formPage === 1}"
            >
                <span class="item-no">
                    01 
                </span>

                Account Details
            </button>

            <button
                class="nav-item"
                @click="changePage(2)"
                :class="{ 'active' : formPage === 2}"
            >
                <span class="item-no">
                    02
                </span>

                Subscription
            </button>
        </section>

        <transition-group name="transition-anim" tag="section">
            <AccountFormDetails
                key="0"
                v-if="formPage === 1"
                :storeModule="storeModule"
            />

            <AccountFormSubscription
                key="1"
                :storeModule="storeModule"
                v-if="formPage === 2"
            />
        </transition-group>
    </section>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import AccountFormDetails from '@/components/layouts/AccountFormDetails'
import AccountFormSubscription from '@/components/layouts/AccountFormSubscription'

export default {
    props: {
        storeModule: {
            type: String,
            default: '',
            required: true
        },

        isApprove: {
            type: Boolean,
            default: false,
        }
    },

    data () {
        return {
            previousCompanyType: {},
            firstLoad: false
        }
    },

    created () {
        this.$store.commit(`accountForm/setFormChangedChecker`)
    },

    watch: {
        'accountForm.company_type': {
            handler: function(val, oldVal) {
                if (this.firstLoad) {
                    this.previousCompanyType = oldVal
                } else {
                    this.previousCompanyType = val
                    this.firstLoad = true
                }
            },
            deep: true,
            immediate: false
        }
    },

    destroyed () {
        this.$store.commit(`accountForm/clearForm`)
    },

    computed: {
        ...mapFields('accountForm', [
            'accountForm',
            'hasFormChangeChecker',
            'hasFormChanged',
            'formLoading',
            'isUpdateAccount',
            'formPage',
            'isPageOneComplete'
        ]),

        ...mapFields('global', [
            'countryList',
            'countryLoading',

            'countryZoneList',
            'countryZoneLoading',

            'countryPartnerList',
            'countryPartnerLoading',

            'partnerList',
            'partnerLoading',

            'sessionTypeList',
            'sessionTypeLoading'
        ]),

        ...mapFields('accountOverview', [
            'accountDetails'
        ]),

        partnerValue () {
            if (!this.partnerList.length || !this.accountForm.partner) return { company_name: '' }

            return this.partnerList.find(i => i.id === this.accountForm.partner)
        },

        confirmText () {
            return this.isUpdateAccount
                ? this.isApprove
                    ? 'Approve'
                    : 'Update'
                : 'Create'
        },

        headerTitleText () {
            return this.isUpdateAccount
                ? this.isApprove
                    ? 'Approve Account'
                    : 'Update Account'
                : 'Create Account'
        }
    },

    methods: {
        /* Change Page */
        async changePage (page) {
            if (page === 2) {
                await this.$store.commit(`accountForm/isPageOneComplete`, this.storeModule)

                if (!this.isPageOneComplete) {
                    await this.$store.commit('modal/toggleNotification', {
                        notificationName: 'notification-banner',
                        notificationType: 'warning',
                        notificationDesc: 'Please fill up all fields.',
                    })

                    return
                }

                // Check Email Validity
                if (this.accountDetails.email !== this.accountForm.email) {
                    this.formLoading = true
                    if (process.env.NODE_ENV === 'production' && process.env.VUE_APP_SERVER !== 'test') {
                        // const isEmailVerified = await this.$options.filters.verifyEmail(this.accountForm.email)
                        const isEmailVerified = await this.$store.dispatch('auth/checkEmail', {email:this.accountForm.email})
        
                        if (!isEmailVerified) {
                            await this.$store.commit('modal/toggleNotification', {
                                notificationName: 'notification-banner',
                                notificationType: 'warning',
                                notificationDesc: 'Email is not valid',
                            })
        
                            this.formLoading = false
                            return
                        }
                    }
                }

                if (this.storeModule === 'registeredAccount') {
                    if (this.accountForm.company_type.id !== this.previousCompanyType.id) {
                        this.accountForm.categories = []
                    }
                }

                this.formLoading = false
            }

            this.formPage = page
        },
        
        /* Form Control */
        async closeForm () {
            if (this.formLoading) return

            await this.$store.commit(`accountForm/hasFormChanged`)

            if (this.hasFormChanged) {
                this.$store.commit('modal/toggleModal', {
                    modalType: 'warning',
                    modalName: 'confirm-modal',
                    modalDesc: 'Your inputs will not be saved.',
                    storeAction: 'modal/closeModal'
                })

                return
            }
            
            this.$store.dispatch('modal/closeModal')
        },
    },

    components: {
        AccountFormDetails,
        AccountFormSubscription
    },
}
</script>

<style lang="scss" scoped>
.account-form {
    display: flex;
    padding-left: 130px !important;

    .form-nav {
        width: 180px;
        margin-right: 20px;
        margin-top: 57px;
        flex-shrink: 0;

        .nav-item {
            display: block;
            background: #FFFFFF;
            box-shadow: 0px 0px 3px #E6EAF2;
            border-radius: 3px;
            width: 100%;
            padding: 15px 25px;
            display: flex;
            justify-content: flex-start;
            color: #DCDDE0;
            transition: 0.3s;

            &:first-child {
                margin-bottom: 15px;
            }

            .item-no {
                margin-right: 10px;
                color: #DCDDE0;
                transition: 0.3s;
            }

            &.active, &:hover {
                color: #778395;
                box-shadow: 0px 0px 20px #E6EAF2;

                .item-no {
                    margin-right: 10px;
                    color: #2DC4B6;
                }
            }
        }
    }
}

.request-form {
    width: 560px;
    padding: 10px 15px;

    .form-header {
        padding-bottom: 10px;
        border-bottom: 1px solid #b4b4b4;
        margin-bottom: 20px;
        margin-top: 0;
    }

    .form-section {
        display: flex;
        align-items: center;

        .form-title {
            font-weight: 600;
            width: 150px;
            flex-shrink: 0;
            font-size: 15px;
            text-align: left;
            transition: 0.3s;
            color: #575B5C;
        }

        &:hover {
            .form-title {
                color: #2DC4B6;
            }
        }

        &.host-name {
            &:hover {
                .form-title {
                    color: #2DC4B6;
                }

                /deep/ .input-wrapper {
                    input {
                        border: 1px solid #2DC4B6;
                    }

                    label {
                        color: #2DC4B6;
                    }
                }
            }

            .input-section {
                display: flex;
                width: 100%;

                /deep/ .input-wrapper {
                    flex-direction: column;
                    flex: 1 1 auto;
                    width: auto;

                    &:first-child {
                        margin-right: 15px;
                    }

                    label {
                        padding-top: 0;
                    }
                }
            }
        }

        &.subscription {
            &:hover {
                .form-title {
                    color: #2DC4B6;
                }

                /deep/ .datepicker-box {
                    /deep/ .input-field {
                        border: 1px solid #2DC4B6;
                    }

                    label {
                        transition: 0.3s;
                        color: #2DC4B6;
                    }
                }
            }

            .datepicker-section {
                display: flex;
                flex: 1 1 auto;

                /deep/ .datepicker-box {
                    padding: 0;

                    &:first-child {
                        margin-right: 10px;
                    }

                    label {
                        height: auto;
                        padding: 0 0 10px 0;
                        font-weight: 600;
                    }
                }
            }
        }

        &.phone {
            .select-box {
                width: 200px;
                margin-right: 15px;
                
                /deep/ .selected-item {
                    padding: 9px 10px;
                    color: #778395;
                }
            }

            .country-code {
                border: 1px solid #C6C6C6;
                border-radius: 4px;
                font-size: 13px;
                width: 170px;
                margin-right: 15px;
                height: 37px;
                background: darken(#fff, 0.8%);
                display: flex;
                align-items: center;
                padding-left: 10px;
                user-select: none;
            }
        }

        &.assign-to {
            .form-title {
                font-weight: 600;
                width: 150px;
                flex-shrink: 0;
                font-size: 15px;
                text-align: left;
                transition: 0.3s;
            }

            .select-box {
                &:not(:last-child) {
                    margin-right: 15px; 
                }
            }
        }

        &:not(:last-child) {
            margin-bottom: 20px;
        }

        /deep/ .input-box, /deep/ .select-box {
            display: flex;
            flex-direction: row;
            width: 100%;

            label {
                font-weight: 600;
                width: 150px;
                font-size: 15px;
                flex-shrink: 0;
            }

            .input-field {
                flex: 1 1 auto;
            }

            .toggle-password {
                top: 7px;
                right: 1px;
                font-size: 13px;
            }
        }
    }

    .btn-container {
        margin-top: 40px;
        display: flex;
        justify-content: space-between;
    }
}
</style>